// To show a column of empty 1x2 placeholders to match up to the number of hdp or o/u runners
const PlaceholderOddsElements = ({ count }: { count: number }) => (
  <>
    {Array.from({ length: count - 1 }).map((_, i) => (
      <div className="asian-marketType-container__onextwo--dummy" key={i}></div>
    ))}
  </>
);

export default PlaceholderOddsElements;
